import Column from "@able/react/dist/Column";
import MessageInline from "@able/react/dist/MessageInline";
import { AbleCommonProps } from "../../Types";
import { TableStatusMessageType } from "../types";

const TableInlineMessage = (props: TableStatusMessageType & AbleCommonProps) => {
    const { developmentUrl, statusMessage, statusMessageVariant } = props;
    return (
        <>
            {statusMessage &&
                <div className="ted-ui-TableMessageInline">
                    <Column bmd={8}>
                        <MessageInline developmentUrl={developmentUrl} variant={statusMessageVariant ?? 'Success'} description={statusMessage} />
                    </Column>
                </div>
            }
        </>
    )
}

export default TableInlineMessage